import { Inject, Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';

import { AsyncJobConfig } from '../async-job-view.types';
import { ASYNC_JOB_CONFIG_TOKEN } from './tokens';

@Injectable({ providedIn: 'root' })
export class AsyncJobConfigService {
  public readonly configMap: Record<AsyncJobType, AsyncJobConfig>;

  constructor(@Inject(ASYNC_JOB_CONFIG_TOKEN) configs: AsyncJobConfig[]) {
    this.configMap = <Record<AsyncJobType, AsyncJobConfig>>(
      Object.fromEntries(configs.map(config => [config.type, config]))
    );
  }

  public get(job: { type: AsyncJobType }) {
    return this.configMap[job.type];
  }
}
